import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Lightning } from "@phosphor-icons/react";
import { AdSlot } from "@/components/AdSlot";
import { TOOLS } from "@/lib/tools";
import { api } from "@/lib/api";

const SLUG_TO_KEY = {
  "thumbnail-downloader": "thumbnails",
  "tag-extractor": "tags",
  "earnings-calculator": "earnings",
  "hashtag-generator": "hashtags",
  "channel-finder": "channel",
  "trending-tags": "trending",
  "ai-titles": "ai_titles",
  "ai-ideas": "ai_ideas",
  "subtitle-extractor": "subtitles",
  "thumbnail-preview": "thumbnail_preview",
  "title-checker": "title_checker",
  "chapter-formatter": "chapter_formatter",
  "reading-timer": "reading_timer",
  "thumbnail-studio": "thumbnail_studio",
  "description-generator": "description_generator",
  "channel-id-converter": "channel_id_converter",
};

export const ToolShell = ({ slug, title, tagline, children, hasResults }) => {
  const related = TOOLS.filter((t) => t.slug !== slug).slice(0, 4);
  const [uses, setUses] = useState(null);

  useEffect(() => {
    api.get("/tool-stats").then((res) => {
      const n = res.data[SLUG_TO_KEY[slug]];
      if (n) setUses(n);
    }).catch(() => {});
  }, [slug]);

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-8 py-6 sm:py-10 lg:py-16">
      <div className="fade-up">
        <div className="flex items-center gap-3 mb-3 flex-wrap">
          <p className="text-xs uppercase tracking-[0.2em] text-[var(--glow)] font-semibold">Free Tool</p>
          {uses && (
            <span
              data-testid="tool-usage-count"
              className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-bold bg-[var(--success)]/12 border border-[var(--success)]/30 text-[var(--success)]"
            >
              <Lightning size={12} weight="fill" /> Used {uses.toLocaleString()} {uses === 1 ? "time" : "times"}
            </span>
          )}
        </div>
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight mb-3">{title}</h1>
        <p className="text-[var(--muted)] text-sm sm:text-base mb-6 sm:mb-10 max-w-xl">{tagline}</p>
      </div>
      <div className="fade-up-1">{children}</div>
      {hasResults && <AdSlot id={`${slug}-results`} className="mt-12" />}
      <div className="mt-12 fade-up-2">
        <h2 className="text-lg font-bold mb-4">Related tools</h2>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
          {related.map((t) => (
            <Link
              key={t.slug}
              to={t.path}
              data-testid={`related-tool-${t.slug}`}
              className="surface rounded-[14px] p-4 lift block"
            >
              <t.icon size={20} color="var(--glow)" weight="duotone" />
              <p className="text-sm font-semibold mt-2">{t.name}</p>
            </Link>
          ))}
        </div>
      </div>
      <AdSlot id={`${slug}-footer`} variant="multiplex" className="mt-12" />
    </div>
  );
};
